import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Iconify from 'src/components/iconify';

interface InfoBoxProps {
  title?: string;
  description?: string;
  icon?: string;
}

export const InfoBox = ({ title, description, icon = 'eva:info-outline' }: InfoBoxProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.info.lighter,
        border: `1px solid ${theme.palette.info.main}`,
        borderRadius: 1,
        p: 1,
        color: theme.palette.info.darker,
        display: 'flex',
        alignItems: 'flex-start',
        gap: 1,
        mb: 2,
      }}
    >
      <Iconify
        icon={icon}
        sx={{
          color: theme.palette.info.main,
          fontSize: '1.2rem',
          mt: 0.1,
          flexShrink: 0,
        }}
      />
      <Box>
        {title && (
          <Typography
            variant="body2"
            sx={{
              fontWeight: 'medium',
              mb: 0.5,
            }}
          >
            {title}
          </Typography>
        )}
        {description && (
          <Typography sx={{ whiteSpace: 'pre-line' }} variant="caption">
            {description}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
